<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	title: 'Browse Authors',
	authors: [{
		name: 'Sarah Cohen',
		title: 'Dr.',
		institution: 'Sample University',
		image: '/webclip.png',
		link: '/authors',
	}],
	allAuthorsLink: '/authors',
}
const schema = defineSchema({
	title: $.text('Title'),
	authors: $.array('Authors', defineSchema({
		name: $.text('Name'),
		title: $.text('Title'),
		institution: $.text('Institution'),
		image: $.upload('Image'),
		link: $.text('Link'),
	}), { collapsible: true }),
	allAuthorsLink: $.text('All Authors Link'),
})
export const BlockAuthorList = defineBlock({ pickerHidden: true, thumbnail: '/block-thumbs/BlockAuthorList.svg', category: 'Listings', order: 120, name: 'BlockAuthorList', label: 'Author List', icon: 'people', schema, defaults })
</script>
<script setup lang="ts">

import { Icon, Image } from '@bagelink/vue'
import { displayImage } from '@/utils/image'




interface Author {
	name: string
	title: string
	institution?: string
	image: string
	link: string
}

interface AuthorListData {
	title: string
	authors: Author[]
	allAuthorsLink: string
}

const props = defineProps<{
	authorListData?: AuthorListData
	title?: string
	authors?: Author[]
	allAuthorsLink?: string
}>()

// Support both nested and flat props
const getTitle = () => props.authorListData?.title || props.title || ''
const getAuthors = () => props.authorListData?.authors || props.authors || []
const getAllAuthorsLink = () => props.authorListData?.allAuthorsLink || props.allAuthorsLink || '/authors'
</script>

<template>
	<div v-if="getAuthors().length" class="m_none">
		<p class="txt17 pb-1">
			{{ getTitle() }}
		</p>

		<div class="authors-grid">
			<router-link
				v-for="author in getAuthors()"
				:key="author.name"
				:to="author.link"
				class="flex gap-1 decoration-none hover color-gray-70 mb-1-5"
			>
				<Image :src="displayImage(author.image, 'thumb')" :alt="author.name" ratio="1" class=" aspect-ratio-1 h45px round " lazy />
				<div class="min-w-0">
					<p class="my-0 txt15 light line-height-12">
						{{ [author.title, author.name].filter(Boolean).join(' ') }}
					</p>
					<p v-if="author.institution" class="my-0 txt12 light line-height-12 pt-025">
						{{ author.institution }}
					</p>
				</div>
			</router-link>
		</div>

		<router-link :to="getAllAuthorsLink()" class="decoration-none flex txt13 hover">
			<p class="color-gray-70">
				All Authors
			</p>
			<Icon name="keyboard_arrow_right" class="line-height-0 color-primary" />
		</router-link>
	</div>
</template>

<style>

</style>
